import { useDispatch } from "react-redux";
import { AsyncThunkAction } from "@reduxjs/toolkit";
import { SliceActionResult } from "./types/sliceAction";

type AsyncDispatch<T> = (thunk: AsyncThunkAction<T, any, any>) => Promise<T>;

export function useDispatchThunk<T = SliceActionResult<any>>(): AsyncDispatch<T> {
  return  useDispatch();
}